export const languagePrefixes = ['MKG', 'Bemet', 'proMExS'];

export const languages = [
  {
    name: 'English',
    title: 'English',
    value: 'en',
  },
  {
    name: 'Nederlands',
    title: 'Dutch',
    value: 'nl',
  },
  {
    name: 'Nederlands-MKG',
    title: 'Dutch-MKG',
    value: 'nl-MKG',
    flag: 'settings-test-language',
  },
  {
    name: 'Nederlands-Bemet',
    title: 'Dutch-Bemet',
    value: 'nl-Bemet',
    flag: 'settings-test-language',
  },
  {
    name: 'Deutsch',
    title: 'German',
    value: 'de',
  },
  {
    name: 'Pseudolocale',
    title: 'Pseudolocale',
    value: 'ps',
    flag: 'settings-pseudolocale-language',
  },
  {
    name: 'Label English',
    title: 'Label English',
    value: 'lbl_en',
    flag: 'settings-pseudolocale-language',
  },
  {
    name: 'Français',
    title: 'French',
    value: 'fr',
  },
  {
    name: 'Italiano',
    title: 'Italian',
    value: 'it',
  },
  {
    name: 'Español',
    title: 'Spanish',
    value: 'es',
  },
  {
    name: 'Português',
    title: 'Portuguese',
    value: 'pt',
  },
  {
    name: '日本',
    title: 'Japanese',
    value: 'ja',
  },
  {
    name: '한국인',
    title: 'Korean',
    value: 'ko',
  },
  {
    name: '中国传统的',
    title: 'Chinese, Simplified',
    value: 'zh-Hans',
    locale: 'zh-cn',
  },
  {
    name: '簡體中文',
    title: 'Chinese, Traditional',
    value: 'zh-Hant',
    locale: 'zh-cn',
  },
  {
    name: 'Українська',
    title: 'Ukrainian',
    value: 'uk',
  },
  {
    name: 'हिन्दी',
    title: 'Hindi',
    value: 'hi',
  },
  {
    name: 'Türkçe',
    title: 'Turkish',
    value: 'tr',
  },
  {
    name: 'Polski',
    title: 'Polish',
    value: 'pl',
  },
  {
    name: 'Čeština',
    title: 'Czech',
    value: 'cs',
  },
  {
    name: 'Română',
    title: 'Romanian',
    value: 'ro',
  },
  {
    name: 'Magyar',
    title: 'Hungarian',
    value: 'hu',
  },
  {
    name: 'Svensk',
    title: 'Swedish',
    value: 'sv',
  },
  {
    name: 'Danska',
    title: 'Danish',
    value: 'da',
  },
  {
    name: 'Norsk',
    title: 'Norwegian',
    value: 'nb',
  },
  {
    name: 'Suomalainen',
    title: 'Finnish',
    value: 'fi',
  },
  {
    name: 'Label Polish',
    title: 'Label Polish',
    value: 'lbl_pl',
    flag: 'settings-pseudolocale-language',
  },
  {
    name: 'Label German',
    title: 'Label German',
    value: 'lbl_de',
    flag: 'settings-pseudolocale-language',
  },
  {
    name: 'Label Dutch',
    title: 'Label Dutch',
    value: 'lbl_nl',
    flag: 'settings-pseudolocale-language',
  },
];
